/**
 * The workspace's real roles and what each can do (2026-09-29). Replaces a
 * static matrix of eight PMI job titles that didn't exist in the system —
 * picking one in "Edit user" silently did nothing.
 */
import type { Role } from '../../services/users'
import { summarisePermissions } from './rolePermissions'

export function RolesOverview({ roles }: { roles: Role[] }) {
  if (roles.length === 0) {
    return <p className="text-sm text-muted-foreground">No roles found.</p>
  }
  return (
    <div className="space-y-4">
      <p className="text-sm text-muted-foreground">
        These are the roles in this workspace and exactly what each allows. Give someone a role from Users → Edit.
      </p>
      <div className="grid gap-4 md:grid-cols-2 xl:grid-cols-3">
        {roles.map((role) => {
          const perms = summarisePermissions((role.permissions ?? []).map((p) => p.name))
          return (
            <section key={role.id} className="rounded-xl border border-border bg-card p-4" aria-label={role.name}>
              <h3 className="font-medium text-foreground">{role.name}</h3>
              {role.description && <p className="mb-3 text-xs text-muted-foreground">{role.description}</p>}
              {perms.length === 0 ? (
                <p className="text-sm text-muted-foreground">No permissions.</p>
              ) : (
                <dl className="space-y-1 text-sm">
                  {perms.map((p) => (
                    <div key={p.resource} className="flex justify-between gap-3">
                      <dt className="text-foreground">{p.resource}</dt>
                      <dd className="text-right text-muted-foreground">{p.actions.join(', ')}</dd>
                    </div>
                  ))}
                </dl>
              )}
            </section>
          )
        })}
      </div>
    </div>
  )
}
